import { useEffect } from 'react';
import { rootStore } from './store-root';
import type { PageType } from '../_utils/types';

interface UseStripesStoreParams {
  favoritesListId?: number;
  universeId?: string;
  pageType: PageType;
}

const useStripesStore = ({ pageType, universeId, favoritesListId }: UseStripesStoreParams) => {
  useEffect(() => {
    const store = rootStore.stripesStore;
    store.setParams({ pageType, universeId, favoritesListId });
    store.fetchUiElements();

    return () => {
      store.stopUiElementsSubscription();
      store.resetUiElements();
      store.setError(null);
    };
  }, [pageType, universeId, favoritesListId]);

  return rootStore.stripesStore;
};

export default useStripesStore;
